module.exports = __webpack_public_path__ + "prod/1.2.3/img/confirming.1ffa75cb.svg";